import { ILightWeightObject } from '../models';

export function fiDoesLightWeightObjectHaveChildren(item: ILightWeightObject, array: ILightWeightObject[]) {
    return !!array.filter((arrayItem: ILightWeightObject) => arrayItem.ParentId == item.Id).length;
}
